import {Component, computed, effect, Signal} from '@angular/core';
import {Airline} from '../../types-workflow';
import {debounceTime, startWith} from 'rxjs/operators';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {FILTER_DEBOUNCE_TIME, FilterSectionComponent} from '../filter-section/filter-section.component';
import {OrgResolverPipe} from '../../pipes/org-resolver-pipe';
import {ContextService} from '../../services/context.service';
import {toSignal} from '@angular/core/rxjs-interop';
import {Apollo} from 'apollo-angular';


@Component({
  selector: 'app-airline-select-sections',
  templateUrl: './airline-select.component.html',
  styleUrls: ['./airline-select.component.scss'],
  imports: [FilterSectionComponent, ReactiveFormsModule, RouterModule, OrgResolverPipe]
})
export class AirlineSelectComponent {
  loading = true;
  airlines: Signal<Airline[]>;
  filteredAirlines: Signal<Airline[]>;
  /**
   * True while we are on our way into the organization's only airline, so the page shows the
   * loading row instead of flashing a one-row table the user never gets to click.
   */
  autoNavigating: Signal<boolean>;
  filters: FormGroup = new FormGroup({
    t: new FormControl<string>(''),
  });

  constructor(private router: Router, contextService: ContextService, activatedRoute: ActivatedRoute, apollo: Apollo) {
    this.airlines = contextService.airlines
    const filterSignal = toSignal(
      this.filters.valueChanges.pipe(
        debounceTime(FILTER_DEBOUNCE_TIME),
        startWith(this.filters.value)
      )
    )
    this.filteredAirlines = computed(() => {
      const f = filterSignal();
      console.log(f)
      this.loading = false;
      if (!f || !f['t'] || f['t'] === '') {
        return this.airlines().sort((a, b) => a.airline_name.localeCompare(b.airline_name));
      } else {
        return this.airlines().filter(airline => {
          return airline.airline_name.toLowerCase().includes((f['t'] || '').toLowerCase()) ||
            airline.iata_code.toLowerCase().includes((f['t'] || '').toLowerCase())
        }).sort((a, b) => a.airline_name.localeCompare(b.airline_name));
      }
    })

    this.autoNavigating = computed(() => contextService.soleAirline() !== null);

    // An organization with a single airline has no selection to make: go straight into it. The
    // navigation replaces the current history entry, so this page never sits between the user and
    // the back button, and the airline picker stays visible for everyone with a real choice.
    effect(() => {
      const soleAirline = contextService.soleAirline();
      if (soleAirline) {
        this.router.navigate([soleAirline.iata_code], {relativeTo: activatedRoute, replaceUrl: true});
      }
    });
  }

}
